import { Omit } from '@40seas/entities/common';
import { TenantlessBaseEntityFieldsArray } from '@40seas/models';
import { FeatureToggle } from './feature-toggle.entity';

export class CreateFeatureToggleDto extends Omit(FeatureToggle, TenantlessBaseEntityFieldsArray) {}
